import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Grid,
  Segment,
  Header,
  Dimmer,
  Loader,
  Progress,
  Statistic,
  Divider,
  Icon,
} from "semantic-ui-react";
import { Redirect } from "react-router-dom";
import Storage from "../utils/Storage";
import Leaderboard from "./Leaderboard";
import Countdown from "./Countdown";
import DashboardApi from "../utils/DashboardApi";
import RoundStatistics from "./RoundStatistics";

var moment = require("moment-timezone");
var DatetimeFormat = "MM-DD-YYYY hh:mm:ss a z";

//MAKE THIS SHIT PRETTY: https://github.com/coreui/coreui-free-react-admin-template TODO
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      admin: Storage.isAdmin(),
      user_rank: null,
      stats: null,
    };

    this.refresh = this.refresh.bind(this);
    this.getRank = this.getRank.bind(this);
  }

  // React state to store user -- hope to move to redux and retrieve user based on credentials

  componentDidMount() {
    if (this.state.loading) {
      this.refresh();
    }
  }

  refresh() {
    window.DashboardApi = DashboardApi
    DashboardApi.stats()
      .then((response) => {
        console.log(response)
        this.setState({
          stats: response.data,
          loading: false,
        });
      })
      .catch((response) => {
        this.setState({
          stats: response.data,
          loading: false,
        });
      });
  }

  getRank(rank) {
    if (rank !== this.state.user_rank) {
      this.setState({
        user_rank: rank,
      });
    }
  }

  render() {
    if (!this.state.loading && this.state.stats == null) {
      Storage.logOut();
      return <Redirect to="/login" />;
    }
    // Map readers for leaderboards -- no sorting as of now. Need to figure out how to sort based on number of apps read
    return (
      <div>
        {this.state.loading && (
          <Dimmer active={this.state.loading} page>
            <Loader>Fetching Data</Loader>
          </Dimmer>
        )}
        {!this.state.loading && (
          <div>
            {/* Navbar */}
            <div style={{ display: "flex", padding: "1.2rem 1.5rem" }}>
              <Button
                as={Link}
                to="/admin"
                style={{ visibility: this.state.admin ? "auto" : "hidden" }}
                floated="left"
                color="blue"
              >
                Admin
              </Button>
              <Header
                as="h2"
                textAlign="center"
                style={{ height: "1em", margin: "auto" }}
              >
                Welcome {this.state.stats.user.name.split(" ")[0]}!
              </Header>
              <Button
                color="orange"
                as={Link}
                to="/login"
                floated="right"
                onClick={Storage.logOut}
              >
                Log Out
              </Button>
            </div>
            <Grid verticalAlign="bottom" style={{ padding: "0" }} columns={3}>
              <Grid.Column width={5} />
              <Grid.Column width={6}>
                <Statistic
                  size="large"
                  color="orange"
                  style={{ marginBottom: "0" }}
                >
                  <Statistic.Label>Current Round:</Statistic.Label>
                  <Statistic.Value>
                    {this.state.stats.global_stats.current_round.round_number}
                  </Statistic.Value>
                </Statistic>
              </Grid.Column>
              <Grid.Column centered width={4}>
                <Statistic
                  size="mini"
                  color="red"
                  style={{
                    marginBottom: "0",
                    marginRight: "0",
                    width: "100%",
                    float: "right",
                  }}
                >
                  <Statistic.Value>
                    {moment(
                      this.state.stats.global_stats.current_round.deadline
                    )
                      .tz("America/New_York")
                      .format("LLL")
                      .concat(" EST")}
                  </Statistic.Value>
                  <br />
                  <Statistic.Label>
                    {" "}
                    <Icon name="hourglass half" />
                    Deadline:
                  </Statistic.Label>
                  <Statistic.Value>
                    <Countdown
                      data={
                        this.state.stats.global_stats.current_round.deadline
                      }
                    />
                  </Statistic.Value>
                </Statistic>
              </Grid.Column>
            </Grid>
            <Segment>
              <RoundStatistics data={this.state.stats.global_stats} />
              <Progress
                percent={
                  (parseFloat(this.state.stats.global_stats.num_graded) /
                    parseFloat(
                      this.state.stats.global_stats.total_reads_needed
                    )) *
                  100
                }
                active
                indicating
                attached="top"
              />
            </Segment>

            <Grid
              stackable
              padded
              relaxed
              columns={2}
              style={{ paddingLeft: "4em", paddingRight: "2em" }}
            >
              <Grid.Column textAlign="center" width={7}>
                {/* User stats */}
                <Segment textAlign="center">
                  <Header textAlign="center" as="h2">
                    Your Progress
                  </Header>
                  <Divider />
                  {this.state.stats.user.active ? (
                    <Statistic.Group size="large" widths="two">
                      <Statistic>
                        <Statistic.Label>Progress</Statistic.Label>
                        <Statistic.Value>
                          {this.state.stats.user_stats.total_apps_read +
                            "/" +
                            this.state.stats.global_stats.grader_target}
                        </Statistic.Value>
                        <Progress
                          value={this.state.stats.user_stats.total_apps_read}
                          total={this.state.stats.global_stats.grader_target}
                          active
                          indicating
                        />
                      </Statistic>
                      <Statistic>
                        <Statistic.Label>Rank</Statistic.Label>
                        <Statistic.Value>
                          {this.state.user_rank}
                        </Statistic.Value>
                      </Statistic>
                    </Statistic.Group>
                  ) : (
                    <Header color="red" textAlign="center" as="h3">
                      You are INACTIVE
                    </Header>
                  )}
                </Segment>

                {/*<Countdown />*/}
              </Grid.Column>
              <Grid.Column
                textAlign="center"
                width={9}
                style={{ paddingLeft: "2em", paddingRight: "4em" }}
              >
                {/* Leaderboards */}
                <Segment basic style={{ overflowY: "auto", padding: "0" }}>
                  <Leaderboard data={this.state.stats} getRank={this.getRank} />
                </Segment>
              </Grid.Column>
            </Grid>
          </div>
        )}
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js